import { render, staticRenderFns } from "./WarrantyDetail.vue?vue&type=template&id=12c404b2&scoped=true"
import script from "./WarrantyDetail.vue?vue&type=script&lang=js"
export * from "./WarrantyDetail.vue?vue&type=script&lang=js"
import style0 from "./WarrantyDetail.vue?vue&type=style&index=0&id=12c404b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c404b2",
  null
  
)

export default component.exports